/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import Spinner from "../../../theme/Spinner";
import { useEffect, useRef, useState } from "react";
import Pagination from "../../../components/Pagination";
import { CURRENCY } from "../../../components/Constants";
import { getPermissions } from "../../../context/AuthContext";
import { errorToast, successToast } from "../../../components/Toast";
import "rsuite/DateRangePicker/styles/index.css";
import { Autocomplete, TextField } from "@mui/material";
import { getBuyerNameListApi } from "../../../services/_buyer";
import {
  deleteMiscellaneousSalesApi,
  getAllMiscellaneousSalesApi,
  getMiscellaneousSalesListApi,
} from "../../../services/_sales";
import ReCAPTCHA from "react-google-recaptcha";

const MiscellaneousSalesList = () => {
  const permissions = getPermissions();
  const [records, setRecords] = useState([]);
  const [buyerList, setBuyerList] = useState([]);
  const [miscellaneousSaleOrders, setMiscellaneousSaleOrders] = useState([]);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [displayFilter, setDisplayFilter] = useState(false);
  const [filterInvoiceId, setFilterInvoiceId] = useState<string>("");
  const [filterBuyerId, setFilterBuyerId] = useState<string>("");
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);
  const [dateRange, setDateRange] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [sortKey, setSortKey] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");
  const recaptchaRef = useRef<any>(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const toggleFilter = async () => {
    setDisplayFilter(!displayFilter);
  };

  const getMiscellaneousSalesList = async (
    page: number,
    perPage: number,
    isFilter?: boolean,
    sortKey?: string,
    sortType?: string
  ) => {
    setLoading(true);
    let query = `page=${page}&per_page=${perPage}`;
    if (isFilter) {
      if (filterInvoiceId) {
        query += `&invoice_id=${filterInvoiceId}`;
      }
      if (dateRange) {
        query += `&from_date=${moment(dateRange[0]).format("YYYY-MM-DD")}`;
        query += `&to_date=${moment(dateRange[1]).format("YYYY-MM-DD")}`;
      }
      if (filterBuyerId) {
        query += `&buyer_id=${filterBuyerId}`;
      }
      if (sortKey && sortType) {
        query += `&sort_key=${sortKey}&sort_type=${sortType}`;
      }
    }
    const result: any = await getMiscellaneousSalesListApi(query);
    if (result.isSuccess) {
      const totalPagesCount = Math.ceil(result.data.total_records / perPage);
      setTotalRecords(result.data.total_records);
      setTotalPages(totalPagesCount);
      setRecords(result.data.records);
    }
    setLoading(false);
  };

  const getBuyerNameList = async () => {
    try {
      const result: any = await getBuyerNameListApi();
      setBuyerList(result.data);
    } catch (error) {
      console.error("Error fetching Buyer Name list", error);
    }
  };

  const getMiscellaneousSalesOrders = async () => {
    try {
      const result: any = await getAllMiscellaneousSalesApi();
      setMiscellaneousSaleOrders(result?.data);
    } catch (error) {
      console.error("Error fetching Miscellaneous SaleOrder list", error);
    }
  };

  const confirmDelete = async () => {
    if (selectedItemId) {
      const result = await deleteMiscellaneousSalesApi(selectedItemId);
      if (result.isSuccess) {
        await getMiscellaneousSalesList(page, perPage);
        successToast(result.message);
      } else {
        errorToast(result.message);
      }
      setSelectedItemId(null);
    }
    resetReCaptcha();
  };

  const handleDeleteClick = (id: any) => {
    if (isCaptchaVerified) {
      resetReCaptcha();
    }
    setSelectedItemId(id);
  };
  const resetReCaptcha = () => {
    recaptchaRef.current?.reset();
    setIsCaptchaVerified(false);
  };

  const filterList = async () => {
    setApplyFilter(true);
    getMiscellaneousSalesList(page, perPage, true);
  };

  const resetList = async () => {
    setPage(1);
    setApplyFilter(false);
    setFilterInvoiceId("");
    getMiscellaneousSalesList(page, perPage);
    setFilterBuyerId("");
    setDateRange(null);
  };

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const sortTable = async (key: string) => {
    let type = sortType === "asc" ? "desc" : "asc";
    if (sortKey !== key) {
      type = "asc";
    }
    setSortKey(key);
    setSortType(type);
    await getMiscellaneousSalesList(page, perPage, true, key, type);
  };

  useEffect(() => {
    getBuyerNameList();
    getMiscellaneousSalesOrders();
  }, []);

  useEffect(() => {
    if (page && perPage) {
      getMiscellaneousSalesList(page, perPage, applyFilter);
    }
  }, [page, perPage, applyFilter]);

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Miscellaneous Sales List</h5>
          </div>

          <div>
            <Link
              to="#"
              type="button"
              className="btn btn-label-github"
              style={{ marginRight: "15px" }}
              onClick={toggleFilter}
            >
              <span>
                <i className="ti ti-filter me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Filter</span>
              </span>
            </Link>
            {permissions.includes("create-miscellaneous-sales") && (
              <Link
                className="btn btn-primary waves-effect waves-light"
                type="button"
                to="/create-miscellaneous-sales"
              >
                <span>
                  <i className="ti ti-plus me-sm-1"></i>
                  <span className="d-none d-sm-inline-block">
                    Create Miscellaneous Sales
                  </span>
                </span>
              </Link>
            )}
          </div>
        </div>

        {displayFilter && (
          <div className="card-body">
            <form className="dt_adv_search">
              <div className="row">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Sale Date:
                      </label>
                      <DateRangePicker
                        format="dd-MM-yyyy"
                        className="form-control"
                        placeholder="From Date ~ To Date"
                        value={dateRange}
                        onChange={(values: any) => {
                          setDateRange(values);
                        }}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Invoice No:
                      </label>
                      <Autocomplete
                        disablePortal
                        options={miscellaneousSaleOrders}
                        getOptionLabel={(option: any) => option.invoice_no}
                        onChange={(e, newValue) => {
                          setFilterInvoiceId(newValue ? newValue.id : "");
                        }}
                        value={
                          miscellaneousSaleOrders.find(
                            (order: any) => order.id === filterInvoiceId
                          ) || null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="form-control"
                            type="text"
                            placeholder="Enter Invoice No"
                            value={filterInvoiceId}
                            onChange={(e) => setFilterInvoiceId(e.target.value)}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Buyer:
                      </label>
                      <select
                        className="form-select"
                        value={filterBuyerId}
                        onChange={(e: any) => {
                          setFilterBuyerId(e.target.value);
                        }}
                      >
                        <option value="">Select Buyer</option>
                        {buyerList.map((buyer: any) => (
                          <option key={buyer.id} value={buyer.id}>
                            {buyer.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={filterList}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-github ms-5"
                        onClick={resetList}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        <div className="card-datatable table-responsive">
          {loading && <Spinner isFullScreen={false} />}
          <table className="dt-advanced-search table table-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("invoice_no")}
                >
                  Invoice No
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("buyer")}
                >
                  Buyer
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("sub_total")}
                >
                  Sub Total
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("gst_amount")}
                >
                  GST Amount
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("total")}
                >
                  Total Amount
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("sale_date")}
                >
                  Sale Date
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                {(permissions.includes("update-miscellaneous-sales") ||
                  permissions.includes("delete-miscellaneous-sales")) && (
                  <th>Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((item: any, i: number) => {
                  return (
                    <tr key={item.id}>
                      <td>{(page - 1) * perPage + 1 + i}</td>
                      <td>
                        {
                          <Link to={`/view-miscellaneous-sales/${item.id}`}>
                            {item.invoice_no}
                          </Link>
                        }
                      </td>
                      <td>{item?.buyer?.name || ""}</td>
                      <td>
                        {CURRENCY.INR.SYMBOL}
                        {parseFloat(item.sub_total).toFixed(2)}
                      </td>
                      <td>
                        {CURRENCY.INR.SYMBOL}
                        {parseFloat(item.gst_amount).toFixed(2)}
                      </td>
                      <td>
                        {CURRENCY.INR.SYMBOL}
                        {parseFloat(item.total).toFixed(2)}
                      </td>
                      <td>{moment(item.sale_date).format("DD-MM-YYYY")}</td>
                      {(permissions.includes("update-miscellaneous-sales") ||
                        permissions.includes("delete-miscellaneous-sales")) && (
                        <td>
                          <>
                            {permissions.includes(
                              "update-miscellaneous-sales"
                            ) && (
                              <Link
                                to={`/edit-miscellaneous-sales/${item.id}`}
                                className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                                title="Edit buyer"
                              >
                                <i className="ti ti-pencil ti-md"></i>
                              </Link>
                            )}
                            {permissions.includes(
                              "delete-miscellaneous-sales"
                            ) && (
                              <Link
                                to={`#`}
                                className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                                data-bs-toggle="modal"
                                data-bs-target="#deleteMiscellaneousSaleModal"
                                onClick={() => handleDeleteClick(item.id)}
                              >
                                <i className="ti ti-trash ti-md"></i>
                              </Link>
                            )}
                          </>
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={
                      permissions.includes("update-miscellaneous-sales") ? 8 : 7
                    }
                    className="text-center"
                  >
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div
            className="modal fade"
            id="deleteMiscellaneousSaleModal"
            tabIndex={-1}
            aria-hidden="true"
          >
            <div className="modal-dialog modal-simple modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <i
                    className="fa-solid fa-circle-exclamation"
                    style={{
                      fontSize: "48px",
                      color: "#ff4c51",
                      marginBottom: "20px",
                      overflow: "hidden",
                    }}
                  ></i>
                  <p style={{ fontSize: "30px" }}>Are you sure?</p>
                  <br />
                  <p style={{ fontSize: "20px" }}>
                    Do you want to delete this <b>Miscellaneous Sale order</b>?
                    <br />
                    This action can't be undone!
                  </p>
                  <div
                    style={{
                      marginTop: "10px",
                      marginLeft: "50px",
                      marginBottom: "10px",
                      height: "80px",
                      width: "305px",
                    }}
                  >
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={
                        process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY || ""
                      }
                      onChange={(value: any) => {
                        if (value) {
                          setIsCaptchaVerified(true);
                        }
                      }}
                    />
                  </div>
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-danger me-3"
                      onClick={() => {
                        confirmDelete();
                        resetList();
                      }}
                      disabled={!isCaptchaVerified}
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </button>
                    <button
                      type="button"
                      className="btn btn-label-secondary"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Pagination
          page={page}
          perPage={perPage}
          totalRecords={totalRecords}
          totalPages={totalPages}
          records={records}
          prevButton={prevButton}
          nextButton={nextButton}
        />
      </div>
    </>
  );
};

export default MiscellaneousSalesList;
